import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBHandsOver = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank officially hands over essential medical equipment to the Ministry of Health at Ndola Teaching Hospital (NTH)</h1>

                    {/*  */}
                    <p className="pb-3">Indo Zambia Bank proudly reaffirmed its commitment to healthcare by officially handing over essential medical equipment to the Ministry of Health at Ndola Teaching Hospital (NTH) valued at over ZMW 422,000.</p>

                    <p className="pb-3">The medical equipment includes 31 hospital beds, 2 patient trolleys and 20 wheelchairs. These critical resources will enhance patient care and support frontline medical teams.</p>

                    <p className="pb-3">The official handover ceremony was graced by the Honourable Minister of Health, Dr. Elijah Muchima MP. The equipment was formally received by the Acting Senior Medical Superintendent, Dr. Tela Bulaya, who will ensure these resources enhance patient care at this critical institution.</p>

                    <p className="pb-3">This initiative is rooted in the bank’s belief that true progress is measured by the well-being of our communities. In his remarks, <b>Indo Zambia Bank Managing Director, Mr. Brajesh Kumar Singh, stated;</b><br/>

                    <em style={{ paddingTop: '10px', display: "block", fontSize: "16px", fontWeight: "400" }}>"We firmly believe that this gesture will serve as a token of appreciation to the management, doctors, nurses and all healthcare workers at Ndola Teaching Hospital for their compassion and selfless work they undertake each and every single day. To the entire health team, I want to say that you are indeed true heroes as you stand on the frontlines to save lives and restore hope in our communities, so this token is meant to remind you that we are with you, and we shall be with you always."</em></p>

                    <p className="pb-3"><b>The Bank is profoundly grateful for the Minister's resonant words of appreciation:</b><br/>

                    <em style={{ paddingTop: '10px', fontSize: "16px", fontWeight: "400" }}>
                    “To our partners, Indo Zambia Bank, I want to commend your continued commitment to national development. You have demonstrated that corporate entities can be powerful agents of change by investing in the health and well-being of communities they serve."</em> - <b>Hon. Dr. Elijah Muchima, MP.</b></p>

                    <p className="pb-3">The Bank is delighted to hand over medical equipment valued at over ZMW 422,000 to the Ministry of Health, reaffirming our unwavering commitment to strengthening healthcare delivery and supporting national development.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #IZB #IZBForYou #LetsGrowTogether #SupportingYouDevelopingZambia #CSR #Ndola #Donation</em></b></p>


            

                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-banner-1.jpg" />
                            </div>
                           <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-banner-2.jpg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-banner-3.jpg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-banner-4.jpg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-banner-5.jpg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-banner-6.jpg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-banner-7.jpg" />
                            </div>
                        </Slider>
                    </div>
                </div>

            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default IZBHandsOver;
